if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span:not(.svg-wrapper)');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (this.cart) this.cartItems = this.cart.querySelector(`${this.cart.nodeName.toLowerCase()}-items`);
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const addOnProducts = this.closest('product-info')?.querySelector('add-on-products');
        let products = [];
        if(addOnProducts) products = addOnProducts.allProducts();
        if (products.length > 0) {
          this.cart = document.querySelector('cart-drawer');
          if (this.cart) this.cartItems = this.cart.querySelector(`${this.cart.nodeName.toLowerCase()}-items`);
          this.addAllToCart(products);
        } else {
          this.addToCart();
        }
      }

      addToCart() {
        this.handleErrorMessage();
        this.handleSuccessMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addingToCart;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append( 'sections', this.cartItems.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute('aria-disabled', true);
              if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.soldOut;
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickModal = this.closest('quick-add-modal') || this.closest('quick-view-modal');
            let quantity = formData.get('quantity') || 1;
            let count = window.cartCount + parseInt(quantity);
            this.cartItems.renderContents(response, count);
            const quickCart = this.closest('cart-drawer') || this.closest('.section-main-cart');
            if(quickCart) return;
            if(quickModal) quickModal.hide();
            if(this.cart.nodeName == 'CART-NOTIFICATION') {
              document.addEventListener('cartNotificationRendered', this.cart.show(), { once: true });
            } else if(this.cart.nodeName == 'CART-DRAWER') {
              document.addEventListener('cartDrawerRendered', this.cart.open(), { once: true });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addedToCart;
            setTimeout(() => {
              this.submitButton.classList.remove('loading');
              if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addToCart;
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }, 500);
          });
      }

      addAllToCart(items) {
        items.push(this.form.querySelector('[name=id]').value);
        const products = {
          items: [...items].map((element => ({
            id: element,
            quantity: 1
          })))
        };
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addingToCart;
        let body;
        if (this.cart) {
          body = JSON.stringify({
            ...products,
            sections: this.cartItems.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          });
          this.cart.setActiveElement(document.activeElement);
        } else {
          body = JSON.stringify({
            ...products
          });
        }
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              this.submitButton.setAttribute('aria-disabled', true);
              if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addToCart;
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            let quantity = items.length || 1;
            let count = window.cartCount + parseInt(quantity);
            this.cartItems.renderContents(response, count);
            document.addEventListener('cartDrawerRendered', this.cart.open(), { once: true });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addedToCart;
            setTimeout(() => {
              this.submitButton.classList.remove('loading');
              if(this.submitButton.getAttribute('data-keep-text') !== 'true') this.submitButtonText.textContent = window.variantStrings.addToCart;
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }, 500);
          });
      }

      handleSuccessMessage(successMessage = false) {
        if (this.hideErrors) return;
        this.successMessageWrapper = this.successMessageWrapper || document.querySelector(`[id="Message-${this.form.getAttribute('id')}"]`);
        if (!this.successMessageWrapper) return;
        this.successMessage = this.successMessage || this.successMessageWrapper.querySelector('.form__message-text');
        if (successMessage) this.successMessage.textContent = successMessage;
        this.successMessageWrapper.toggleAttribute('hidden', !successMessage);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.form__message--error');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.form__message-text');
        if (errorMessage) this.errorMessage.textContent = errorMessage;
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      }
    }
  );
}